export default __webpack_public_path__ + "static/media/banner.ddd3a72e.jpg";